import { DispatchBoardQueueStatus } from "app/data/city-delivery/dispatch-board/models";
import React, { memo } from "react";
import Loading from "ui-components/loading/loading";
import { useGetDispatchBoardQueueLoadDetails } from "../../hooks/useDispatchBoardQueueLoadDetails";
import CityDeliveryLoadDetailStop from "./cityDeliveryLoadDetailStop";

export interface CityDeliveryDispatchWorkflowLoadDetailsProps {
    terminalNumber: number | undefined;
    picklistNumber?: number;
    manifestNumber?: number;
    dispatchLoadStatus: DispatchBoardQueueStatus;
}

const CityDeliveryDispatchWorkflowLoadDetails: React.FC<CityDeliveryDispatchWorkflowLoadDetailsProps> = memo((props) => {
    const hasIdentifier =
        props.terminalNumber != null &&
        (props.picklistNumber != null || props.manifestNumber != null);

    const {
        loadDetails,
        isLoadingLoadDetails,
        isFetchingLoadDetails,
        isErrorLoadDetails,
    } = useGetDispatchBoardQueueLoadDetails({
        terminalNumber: props.terminalNumber,
        picklistNumber: props.picklistNumber,
        manifestNumber: props.manifestNumber,
    });

    const showLoading = hasIdentifier && (isLoadingLoadDetails || (isFetchingLoadDetails && !loadDetails?.length));
    const showDetails = hasIdentifier && loadDetails && loadDetails.length > 0 && !showLoading;
    const showEmpty = hasIdentifier && !showLoading && (!loadDetails || loadDetails.length === 0);
    const showUnavailable = !hasIdentifier;

    return (
        <div className="city-delivery-dispatch-workflow__load-details">
            {showLoading && (
                <div className="city-delivery-dispatch-workflow__load-details__loading">
                    <Loading isLoading={true} />
                    <span>Loading load details…</span>
                </div>
            )}
            {showDetails && (
                <div className="city-delivery-dispatch-workflow__load-details__list">
                    {loadDetails!.map((stop, idx) => (
                        <CityDeliveryLoadDetailStop key={`stop-${stop.sequenceNumber}-${idx}`} stop={stop} />
                    ))}
                </div>
            )}
            {showEmpty && !isErrorLoadDetails && (
                <div className="city-delivery-dispatch-workflow__load-details__empty">
                    No load details available.
                </div>
            )}
            {isErrorLoadDetails && (
                <div className="city-delivery-dispatch-workflow__load-details__error">
                    Failed to load details.
                </div>
            )}
            {showUnavailable && (
                <div className="city-delivery-dispatch-workflow__load-details__unavailable">
                    Details not available for the current status.
                </div>
            )}
        </div>
    );
});

export default CityDeliveryDispatchWorkflowLoadDetails;
